import React, { Component } from "react";
import Tabs from "@cloudscape-design/components/tabs";
import FormField from "@cloudscape-design/components/form-field";
import Input from "@cloudscape-design/components/input";
import Button from "@cloudscape-design/components/button";
import Box from "@cloudscape-design/components/box";
import SpaceBetween from "@cloudscape-design/components/space-between";
import Select from "@cloudscape-design/components/select";
import Container from "@cloudscape-design/components/container";
import Table from "@cloudscape-design/components/table";
import Header from "@cloudscape-design/components/header";
import Grid from "@cloudscape-design/components/grid";
import DatePicker from "@cloudscape-design/components/date-picker";
import Textarea from "@cloudscape-design/components/textarea";
import { PARTNER_PAYMENT_TYPE_OPTIONS } from "../helpers/cohortConditions";

class GamesSweepstakesTriggersTab extends Component {
	state = {
		messageValidationVisibility: {},
		jsonDraft: null,
		jsonError: "",
	};

	static createEmptyTriggerScenarioState() {
		return {
			cohortConditions: [],
			messages: [""],
		};
	}

	static createEmptyTriggerEditorScenarioState() {
		return {
			cohortGroups: [],
			newConditionByGroupId: {},
		};
	}

	static createInitialTriggerValues() {
		return {
			lessThanTicket: GamesSweepstakesTriggersTab.createEmptyTriggerScenarioState(),
			ticketToDouble: GamesSweepstakesTriggersTab.createEmptyTriggerScenarioState(),
		};
	}

	static createInitialTriggerEditorState() {
		return {
			activeScenarioTab: "lessThanTicket",
			activeSectionTab: "messages",
			lessThanTicket: GamesSweepstakesTriggersTab.createEmptyTriggerEditorScenarioState(),
			ticketToDouble: GamesSweepstakesTriggersTab.createEmptyTriggerEditorScenarioState(),
		};
	}

	static buildGroupKeyByModule(module) {
		if (module === "deposit") return "depositFilters";
		if (module === "withdrawal") return "withdrawalFilters";
		if (module === "registration") return "registrationFilters";
		return "profileFilters";
	}

	static buildCohortModuleOptions() {
		return [
			{ value: "deposit", label: "Deposit" },
			{ value: "withdrawal", label: "Withdrawal" },
			{ value: "registration", label: "Registration" },
			{ value: "profile", label: "Profile" },
		];
	}

	static buildLogicalOperatorOptions() {
		return [
			{ value: "AND", label: "AND" },
			{ value: "OR", label: "OR" },
		];
	}

	static buildCohortFieldOptions() {
		return [
			{ value: "id", label: "Id", type: "string" },
			{ value: "risk_model", label: "Risk model", type: "string" },
			{ value: "verify", label: "Verify", type: "select", specialType: "boolean" },
			{ value: "sweepstakes_count", label: "Sweepstakes_count", type: "count" },
			{ value: "email", label: "Email", type: "select", specialType: "boolean" },
			{ value: "phone", label: "Phone", type: "select", specialType: "boolean" },
			{ value: "tg", label: "Telegram", type: "select", specialType: "boolean" },
			{ value: "partnerName", label: "Partner Name", type: "string" },
			{ value: "paymentType", label: "Payment Type", type: "select", specialType: "partnerPaymentType" },
			{ value: "trafficType", label: "Traffic Type", type: "string" },
			{ value: "deposit_date", label: "Deposit date", type: "count" },
			{ value: "deposit_date_crypto", label: "Deposit crypto date", type: "count" },
			{ value: "deposit_date_fiat", label: "Deposit fiat date", type: "count" },
			{ value: "deposit_count", label: "Deposit count", type: "count" },
			{ value: "deposit_count_fiat", label: "Deposit fiat count", type: "count" },
			{ value: "deposit_count_crypto", label: "Deposit crypto count", type: "count" },
			{ value: "deposit_from", label: "Deposit from", type: "date" },
			{ value: "deposit_to", label: "Deposit to", type: "date" },
			{ value: "deposit_crypto_from", label: "Deposit crypto from", type: "date" },
			{ value: "deposit_crypto_to", label: "Deposit crypto to", type: "date" },
			{ value: "deposit_fiat_from", label: "Deposit fiat from", type: "date" },
			{ value: "deposit_fiat_to", label: "Deposit fiat to", type: "date" },
			{ value: "deposit_amount_to", label: "Deposit amount to", type: "count" },
			{ value: "deposit_amount_from", label: "Deposit amount from", type: "count" },
			{ value: "deposit_amount_crypto_to", label: "Deposit amount crypto to", type: "count" },
			{ value: "deposit_amount_crypto_from", label: "Deposit amount crypto from", type: "count" },
			{ value: "deposit_amount_fiat_to", label: "Deposit amount fiat to", type: "count" },
			{ value: "deposit_amount_fiat_from", label: "Deposit amount fiat from", type: "count" },
			{ value: "deposit_type", label: "Deposit type", type: "select", specialType: "cryptoOrFiat" },
			{ value: "withdrawal_date", label: "Withdrawal date", type: "count" },
			{ value: "withdrawal_date_crypto", label: "Withdrawal crypto date", type: "count" },
			{ value: "withdrawal_date_fiat", label: "Withdrawal fiat date", type: "count" },
			{ value: "withdrawal_count", label: "Withdrawal count", type: "count" },
			{ value: "withdrawal_count_fiat", label: "Withdrawal fiat count", type: "count" },
			{ value: "withdrawal_count_crypto", label: "Withdrawal crypto count", type: "count" },
			{ value: "withdrawal_from", label: "Withdrawal from", type: "date" },
			{ value: "withdrawal_to", label: "Withdrawal to", type: "date" },
			{ value: "withdrawal_crypto_from", label: "Withdrawal crypto from", type: "date" },
			{ value: "withdrawal_crypto_to", label: "Withdrawal crypto to", type: "date" },
			{ value: "withdrawal_fiat_from", label: "Withdrawal fiat from", type: "date" },
			{ value: "withdrawal_fiat_to", label: "Withdrawal fiat to", type: "date" },
			{ value: "withdrawal_amount_to", label: "Withdrawal amount to", type: "count" },
			{ value: "withdrawal_amount_from", label: "Withdrawal amount from", type: "count" },
			{ value: "withdrawal_amount_crypto_to", label: "Withdrawal amount crypto to", type: "count" },
			{ value: "withdrawal_amount_crypto_from", label: "Withdrawal amount crypto from", type: "count" },
			{ value: "withdrawal_amount_fiat_to", label: "Withdrawal fiat amount to", type: "count" },
			{ value: "withdrawal_amount_fiat_from", label: "Withdrawal fiat amount from", type: "count" },
			{ value: "withdrawal_type", label: "Withdrawal type", type: "select", specialType: "cryptoOrFiat" },
			{ value: "spins", label: "Spins", type: "count" },
			{ value: "lvl_club", label: "Club", type: "count" },
			{ value: "referer", label: "Referer", type: "count" },
			{ value: "balance", label: "Balance", type: "count" },
			{ value: "registration_from", label: "Registration from", type: "date" },
			{ value: "registration_to", label: "Registration to", type: "date" },
			{ value: "registration_date", label: "Registration user days", type: "count" },
		];
	}

	static buildCohortFieldOptionsByModule(module) {
		const fields = GamesSweepstakesTriggersTab.buildCohortFieldOptions();

		if (module === "deposit") return fields.filter((field) => field.value.startsWith("deposit_"));
		if (module === "withdrawal") return fields.filter((field) => field.value.startsWith("withdrawal_"));
		if (module === "registration") return fields.filter((field) => field.value.startsWith("registration_"));

		return fields.filter((field) => !field.value.startsWith("deposit_") && !field.value.startsWith("withdrawal_") && !field.value.startsWith("registration_"));
	}

	static getScenarioKeys() {
		return ["lessThanTicket", "ticketToDouble"];
	}

	static getScenarioLabel(scenarioKey) {
		if (scenarioKey === "lessThanTicket") return "Prize less than ticket";
		if (scenarioKey === "ticketToDouble") return "Prize x1-x2 from ticket";
		return scenarioKey;
	}

	static getInternationalMessageKeyPrefix() {
		return ["sweepstakes", "triggersText"];
	}

	static getDefaultInternationalMessageKey() {
		return "your key";
	}

	static getInternationalMessageDescription() {
		return 'Enter only the last translation key. It will be sent as ["sweepstakes", "triggersText", "<your key>"].';
	}

	static getInternationalMessageDisplayValue(message) {
		const trimmedMessage = String(message || "").trim();

		if (!trimmedMessage) return "";

		try {
			const parsedMessage = JSON.parse(trimmedMessage);

			if (Array.isArray(parsedMessage) && parsedMessage.every((messageKey) => typeof messageKey === "string")) {
				return String(parsedMessage[parsedMessage.length - 1] || "").trim();
			}
		} catch (error) {
			return trimmedMessage;
		}

		return trimmedMessage;
	}

	static buildInternationalMessagePayloadValue(message) {
		const messageKey = GamesSweepstakesTriggersTab.getInternationalMessageDisplayValue(message);
		if (!messageKey) return "";
		return JSON.stringify([...GamesSweepstakesTriggersTab.getInternationalMessageKeyPrefix(), messageKey]);
	}

	static getInternationalMessageValidationError(message) {
		const trimmedMessage = String(message || "").trim();

		if (!trimmedMessage) return "Message key is required";

		if (trimmedMessage.startsWith("[") || trimmedMessage.startsWith("{")) {
			return 'Enter only the last key, for example "welcomeBonus". The full path is added automatically.';
		}

		return "";
	}

	static applyGroupConditionsConsistency(conditions, groupId) {
		const groupConditions = (conditions || []).filter((condition) => condition.groupId === groupId).sort((a, b) => (a.conditionOrder ?? 0) - (b.conditionOrder ?? 0));

		if (!groupConditions.length) return conditions;

		const firstId = groupConditions[0].id;
		return (conditions || []).map((condition) => {
			if (condition.groupId !== groupId) return condition;
			if (condition.id === firstId) return { ...condition, logicalOperator: null };
			if (!condition.logicalOperator) return { ...condition, logicalOperator: "AND" };
			return condition;
		});
	}

	static buildScenarioEditorStateFromConditions(rawConditions) {
		const fieldMetaByValue = new Map(GamesSweepstakesTriggersTab.buildCohortFieldOptions().map((field) => [field.value, field]));
		const deriveModule = (field) => {
			if (!field) return "profile";
			if (field.startsWith("deposit_")) return "deposit";
			if (field.startsWith("withdrawal_")) return "withdrawal";
			if (field.startsWith("registration_")) return "registration";
			return "profile";
		};
		const conditions = Array.isArray(rawConditions) ? rawConditions.filter(Boolean) : [];

		if (!conditions.length) {
			const groupId = crypto.randomUUID();
			return {
				groups: [{ groupId, module: "deposit", groupKey: "depositFilters", groupLogicalOperator: null }],
				conditions: [],
			};
		}

		const hasAllGroupIds = conditions.every((condition) => condition && typeof condition === "object" && condition.groupId);

		if (!hasAllGroupIds) {
			const hasAnyGroupKey = conditions.some((condition) => condition && typeof condition === "object" && condition.groupKey);

			if (hasAnyGroupKey) {
				const groupsByKey = new Map();
				const groupKeysOrder = [];

				conditions.forEach((condition) => {
					const field = condition.field || condition.fieldLabel || "";
					const module = deriveModule(field);
					const groupKey = condition.groupKey || GamesSweepstakesTriggersTab.buildGroupKeyByModule(module);
					if (groupsByKey.has(groupKey)) return;

					const groupId = crypto.randomUUID();
					const groupLogicalOperator = groupKeysOrder.length === 0 ? null : "AND";
					groupsByKey.set(groupKey, { groupId, module, groupKey, groupLogicalOperator });
					groupKeysOrder.push(groupKey);
				});

				const groups = groupKeysOrder.map((groupKey, index) => {
					const group = groupsByKey.get(groupKey);
					return {
						groupId: group.groupId,
						module: group.module || "deposit",
						groupKey: group.groupKey,
						groupLogicalOperator: index === 0 ? null : group.groupLogicalOperator || "AND",
					};
				});

				const groupMetaByKey = new Map(groups.map((group, index) => [group.groupKey, { ...group, groupOrder: index }]));
				const conditionOrderByGroupId = new Map();

				let nextConditions = conditions
					.map((condition) => {
						const field = condition.field || condition.fieldLabel || "";
						const module = deriveModule(field);
						const groupKey = condition.groupKey || GamesSweepstakesTriggersTab.buildGroupKeyByModule(module);
						const meta = groupMetaByKey.get(groupKey);
						if (!meta) return null;

						const previousOrder = conditionOrderByGroupId.get(meta.groupId) ?? -1;
						const conditionOrder = previousOrder + 1;
						conditionOrderByGroupId.set(meta.groupId, conditionOrder);

						const fieldMeta = fieldMetaByValue.get(field);

						return {
							...condition,
							id: condition.id || crypto.randomUUID(),
							field,
							fieldLabel: condition.fieldLabel || fieldMeta?.label || condition.field || field || "",
							conditionalType: condition.conditionalType || fieldMeta?.type,
							specialType: typeof condition.specialType !== "undefined" ? condition.specialType : fieldMeta?.specialType,
							groupId: meta.groupId,
							module: meta.module,
							groupKey: meta.groupKey,
							groupOrder: meta.groupOrder,
							groupLogicalOperator: meta.groupOrder === 0 ? null : meta.groupLogicalOperator || "AND",
							conditionOrder: typeof condition.conditionOrder === "number" ? condition.conditionOrder : conditionOrder,
							logicalOperator: conditionOrder === 0 ? null : condition.logicalOperator || "AND",
						};
					})
					.filter(Boolean);

				groups.forEach((group) => {
					nextConditions = GamesSweepstakesTriggersTab.applyGroupConditionsConsistency(nextConditions, group.groupId);
				});

				return { groups, conditions: nextConditions };
			}

			const groupsByModule = new Map();
			const modulesOrder = [];

			conditions.forEach((condition) => {
				const module = deriveModule(condition.field || condition.fieldLabel || "");
				if (groupsByModule.has(module)) return;

				const groupId = crypto.randomUUID();
				const groupLogicalOperator = modulesOrder.length === 0 ? null : "AND";
				groupsByModule.set(module, {
					groupId,
					module,
					groupKey: GamesSweepstakesTriggersTab.buildGroupKeyByModule(module),
					groupLogicalOperator,
				});
				modulesOrder.push(module);
			});

			const groups = modulesOrder.map((module, index) => {
				const group = groupsByModule.get(module);
				return {
					...group,
					groupLogicalOperator: index === 0 ? null : group.groupLogicalOperator || "AND",
				};
			});

			const groupMetaByModule = new Map(groups.map((group, index) => [group.module, { ...group, groupOrder: index }]));
			const conditionOrderByGroupId = new Map();

			let nextConditions = conditions.map((condition) => {
				const module = deriveModule(condition.field || condition.fieldLabel || "");
				const meta = groupMetaByModule.get(module);
				const previousOrder = conditionOrderByGroupId.get(meta.groupId) ?? -1;
				const conditionOrder = previousOrder + 1;
				conditionOrderByGroupId.set(meta.groupId, conditionOrder);
				const field = condition.field || condition.fieldLabel || "";
				const fieldMeta = fieldMetaByValue.get(field);

				return {
					...condition,
					id: condition.id || crypto.randomUUID(),
					field,
					fieldLabel: condition.fieldLabel || fieldMeta?.label || condition.field || field || "",
					conditionalType: condition.conditionalType || fieldMeta?.type,
					specialType: typeof condition.specialType !== "undefined" ? condition.specialType : fieldMeta?.specialType,
					groupId: meta.groupId,
					module: meta.module,
					groupKey: condition.groupKey || meta.groupKey,
					groupOrder: meta.groupOrder,
					groupLogicalOperator: meta.groupOrder === 0 ? null : meta.groupLogicalOperator || "AND",
					conditionOrder: typeof condition.conditionOrder === "number" ? condition.conditionOrder : conditionOrder,
					logicalOperator: conditionOrder === 0 ? null : condition.logicalOperator || "AND",
				};
			});

			groups.forEach((group) => {
				nextConditions = GamesSweepstakesTriggersTab.applyGroupConditionsConsistency(nextConditions, group.groupId);
			});

			return { groups, conditions: nextConditions };
		}

		const groupMeta = new Map();
		const firstSeenOrder = new Map();

		conditions.forEach((condition, index) => {
			if (!condition || typeof condition !== "object") return;
			if (!firstSeenOrder.has(condition.groupId)) firstSeenOrder.set(condition.groupId, index);

			const field = condition.field || condition.fieldLabel || "";
			const module = condition.module || deriveModule(field);

			if (!groupMeta.has(condition.groupId)) {
				groupMeta.set(condition.groupId, {
					groupId: condition.groupId,
					module,
					groupKey: condition.groupKey || GamesSweepstakesTriggersTab.buildGroupKeyByModule(module),
					groupLogicalOperator: condition.groupLogicalOperator || null,
					groupOrder: typeof condition.groupOrder === "number" ? condition.groupOrder : firstSeenOrder.get(condition.groupId),
				});
			}

			const meta = groupMeta.get(condition.groupId);
			if (!meta.module) meta.module = module;
			if (typeof condition.groupOrder === "number") meta.groupOrder = condition.groupOrder;
			if (condition.groupKey) meta.groupKey = condition.groupKey;
			if (condition.groupLogicalOperator) meta.groupLogicalOperator = condition.groupLogicalOperator;
		});

		const groups = [...groupMeta.values()]
			.sort((a, b) => (a.groupOrder ?? 0) - (b.groupOrder ?? 0))
			.map((group, index) => ({
				groupId: group.groupId,
				module: group.module || "deposit",
				groupKey: group.groupKey || GamesSweepstakesTriggersTab.buildGroupKeyByModule(group.module || "deposit"),
				groupLogicalOperator: index === 0 ? null : group.groupLogicalOperator || "AND",
			}));

		const indexByGroupId = new Map(groups.map((group, index) => [group.groupId, index]));
		const nextOrderByGroupId = new Map();

		let nextConditions = conditions
			.filter((condition) => condition && typeof condition === "object" && indexByGroupId.has(condition.groupId))
			.map((condition) => {
				const groupIndex = indexByGroupId.get(condition.groupId);
				const group = groups[groupIndex];
				const previousOrder = nextOrderByGroupId.get(condition.groupId) ?? -1;
				const conditionOrder = typeof condition.conditionOrder === "number" ? condition.conditionOrder : previousOrder + 1;
				nextOrderByGroupId.set(condition.groupId, Math.max(previousOrder, conditionOrder));
				const field = condition.field || condition.fieldLabel || "";
				const fieldMeta = fieldMetaByValue.get(field);

				return {
					...condition,
					id: condition.id || crypto.randomUUID(),
					field,
					fieldLabel: condition.fieldLabel || fieldMeta?.label || condition.field || field || "",
					conditionalType: condition.conditionalType || fieldMeta?.type,
					specialType: typeof condition.specialType !== "undefined" ? condition.specialType : fieldMeta?.specialType,
					groupId: group.groupId,
					module: group.module,
					groupKey: condition.groupKey || group.groupKey || GamesSweepstakesTriggersTab.buildGroupKeyByModule(group.module),
					groupOrder: groupIndex,
					groupLogicalOperator: groupIndex === 0 ? null : group.groupLogicalOperator || "AND",
					conditionOrder,
					logicalOperator: conditionOrder === 0 ? null : condition.logicalOperator || "AND",
				};
			});

		groups.forEach((group) => {
			nextConditions = GamesSweepstakesTriggersTab.applyGroupConditionsConsistency(nextConditions, group.groupId);
		});

		return { groups, conditions: nextConditions };
	}

	static buildTriggerStateFromResponse(response) {
		const buildScenarioStateFromResponse = (scenario) => {
			const editorState = GamesSweepstakesTriggersTab.buildScenarioEditorStateFromConditions(scenario?.cohortConditions || []);
			const messages = Array.isArray(scenario?.messages)
				? scenario.messages
						.filter((message) => typeof message === "string")
						.map((message) => GamesSweepstakesTriggersTab.getInternationalMessageDisplayValue(message))
						.filter(Boolean)
				: [];

			return {
				value: {
					cohortConditions: editorState.conditions,
					messages: messages.length ? messages : [""],
				},
				editor: {
					cohortGroups: editorState.groups,
					newConditionByGroupId: {},
				},
			};
		};

		const lessThanTicket = buildScenarioStateFromResponse(response?.lessThanTicket);
		const ticketToDouble = buildScenarioStateFromResponse(response?.ticketToDouble);

		return {
			triggerValues: {
				lessThanTicket: lessThanTicket.value,
				ticketToDouble: ticketToDouble.value,
			},
			triggerEditor: {
				activeScenarioTab: "lessThanTicket",
				activeSectionTab: "messages",
				lessThanTicket: lessThanTicket.editor,
				ticketToDouble: ticketToDouble.editor,
			},
		};
	}

	setModalError = (text, code = 500) => {
		this.props.setGamesSweepstakesModal((prev) => ({
			...prev,
			loaded: true,
			error: {
				text,
				code,
				timestamp: Date.now(),
			},
		}));
	};

	getTriggerValues = () => this.props.gamesSweepstakesModal.triggerValues || GamesSweepstakesTriggersTab.createInitialTriggerValues();

	getTriggerEditor = () => this.props.gamesSweepstakesModal.triggerEditor || GamesSweepstakesTriggersTab.createInitialTriggerEditorState();

	getMessageValidationKey = (scenarioKey, index) => `${scenarioKey}:${index}`;

	isMessageValidationVisible = (scenarioKey, index) => Boolean(this.state.messageValidationVisibility[this.getMessageValidationKey(scenarioKey, index)]);

	showMessageValidation = (scenarioKey, index) => {
		const key = this.getMessageValidationKey(scenarioKey, index);
		this.setState((prevState) => ({
			messageValidationVisibility: {
				...prevState.messageValidationVisibility,
				[key]: true,
			},
		}));
	};

	showScenarioMessagesValidation = (scenarioKey) => {
		const triggerValues = this.getTriggerValues();
		const messages = triggerValues[scenarioKey]?.messages || [""];

		this.setState((prevState) => {
			const nextVisibility = { ...prevState.messageValidationVisibility };

			messages.forEach((_, index) => {
				nextVisibility[this.getMessageValidationKey(scenarioKey, index)] = true;
			});

			return {
				messageValidationVisibility: nextVisibility,
			};
		});
	};

	showAllMessagesValidation = () => {
		this.showScenarioMessagesValidation("lessThanTicket");
		this.showScenarioMessagesValidation("ticketToDouble");
	};

	patchScenario = (scenarioKey, patch) => {
		this.props.setGamesSweepstakesModal((prev) => {
			const currentTriggerValues = prev.triggerValues || GamesSweepstakesTriggersTab.createInitialTriggerValues();
			const currentScenario = currentTriggerValues[scenarioKey] || GamesSweepstakesTriggersTab.createEmptyTriggerScenarioState();
			return {
				...prev,
				triggerValues: {
					...currentTriggerValues,
					[scenarioKey]: {
						...currentScenario,
						...patch,
					},
				},
			};
		});
	};

	patchScenarioEditor = (scenarioKey, patch) => {
		this.props.setGamesSweepstakesModal((prev) => {
			const currentTriggerEditor = prev.triggerEditor || GamesSweepstakesTriggersTab.createInitialTriggerEditorState();
			const currentScenarioEditor = currentTriggerEditor[scenarioKey] || GamesSweepstakesTriggersTab.createEmptyTriggerEditorScenarioState();
			return {
				...prev,
				triggerEditor: {
					...currentTriggerEditor,
					[scenarioKey]: {
						...currentScenarioEditor,
						...patch,
					},
				},
			};
		});
	};

	setActiveScenarioTab = (scenarioKey) => {
		if (scenarioKey === "json") {
			this.syncJsonDraft();
		}

		this.props.setGamesSweepstakesModal((prev) => ({
			...prev,
			triggerEditor: {
				...(prev.triggerEditor || GamesSweepstakesTriggersTab.createInitialTriggerEditorState()),
				activeScenarioTab: scenarioKey,
			},
		}));
	};

	setActiveSectionTab = (sectionKey) => {
		this.props.setGamesSweepstakesModal((prev) => ({
			...prev,
			triggerEditor: {
				...(prev.triggerEditor || GamesSweepstakesTriggersTab.createInitialTriggerEditorState()),
				activeSectionTab: sectionKey,
			},
		}));
	};

	updateNewCondition = (scenarioKey, groupId, patch) => {
		const triggerEditor = this.getTriggerEditor();
		this.patchScenarioEditor(scenarioKey, {
			newConditionByGroupId: {
				...(triggerEditor[scenarioKey]?.newConditionByGroupId || {}),
				[groupId]: {
					...(triggerEditor[scenarioKey]?.newConditionByGroupId?.[groupId] || {}),
					...patch,
				},
			},
		});
	};

	resetNewCondition = (scenarioKey, groupId) => {
		const triggerEditor = this.getTriggerEditor();
		this.patchScenarioEditor(scenarioKey, {
			newConditionByGroupId: {
				...(triggerEditor[scenarioKey]?.newConditionByGroupId || {}),
				[groupId]: {},
			},
		});
	};

	addScenarioMessage = (scenarioKey) => {
		this.showScenarioMessagesValidation(scenarioKey);
		const triggerValues = this.getTriggerValues();
		this.patchScenario(scenarioKey, {
			messages: [...(triggerValues[scenarioKey]?.messages || [""]), ""],
		});
	};

	updateScenarioMessage = (scenarioKey, index, value) => {
		const triggerValues = this.getTriggerValues();
		const nextMessages = [...(triggerValues[scenarioKey]?.messages || [""])];
		nextMessages[index] = value;
		this.patchScenario(scenarioKey, { messages: nextMessages });
	};

	removeScenarioMessage = (scenarioKey, index) => {
		const triggerValues = this.getTriggerValues();
		const nextMessages = [...(triggerValues[scenarioKey]?.messages || [""])].filter((_, messageIndex) => messageIndex !== index);
		this.patchScenario(scenarioKey, { messages: nextMessages.length ? nextMessages : [""] });
	};

	addCohortGroup = (scenarioKey) => {
		const triggerEditor = this.getTriggerEditor();
		const groups = [...(triggerEditor[scenarioKey]?.cohortGroups || [])];
		const groupId = crypto.randomUUID();
		this.patchScenarioEditor(scenarioKey, {
			cohortGroups: [
				...groups,
				{
					groupId,
					module: "deposit",
					groupKey: "depositFilters",
					groupLogicalOperator: groups.length === 0 ? null : "AND",
				},
			],
		});
	};

	updateCohortGroup = (scenarioKey, groupId, patch) => {
		const triggerEditor = this.getTriggerEditor();
		const triggerValues = this.getTriggerValues();
		const nextGroups = (triggerEditor[scenarioKey]?.cohortGroups || []).map((group) => (group.groupId === groupId ? { ...group, ...patch } : group));
		this.patchScenarioEditor(scenarioKey, { cohortGroups: nextGroups });

		const updatedConditions = (triggerValues[scenarioKey]?.cohortConditions || []).map((condition) =>
			condition.groupId === groupId
				? {
						...condition,
						...(typeof patch.module !== "undefined" ? { module: patch.module, groupKey: GamesSweepstakesTriggersTab.buildGroupKeyByModule(patch.module) } : {}),
						...(typeof patch.groupLogicalOperator !== "undefined" ? { groupLogicalOperator: patch.groupLogicalOperator } : {}),
				  }
				: condition,
		);
		this.patchScenario(scenarioKey, { cohortConditions: updatedConditions });
	};

	changeCohortGroupModule = (scenarioKey, groupId, module) => {
		const triggerEditor = this.getTriggerEditor();
		const triggerValues = this.getTriggerValues();
		const nextGroups = (triggerEditor[scenarioKey]?.cohortGroups || []).map((group) => (group.groupId === groupId ? { ...group, module, groupKey: GamesSweepstakesTriggersTab.buildGroupKeyByModule(module) } : group));
		this.patchScenarioEditor(scenarioKey, { cohortGroups: nextGroups });
		this.patchScenario(scenarioKey, {
			cohortConditions: (triggerValues[scenarioKey]?.cohortConditions || []).filter((condition) => condition.groupId !== groupId),
		});
		this.resetNewCondition(scenarioKey, groupId);
	};

	removeCohortGroup = (scenarioKey, groupId) => {
		const triggerEditor = this.getTriggerEditor();
		const triggerValues = this.getTriggerValues();
		const nextGroups = (triggerEditor[scenarioKey]?.cohortGroups || [])
			.filter((group) => group.groupId !== groupId)
			.map((group, index) => ({
				...group,
				groupLogicalOperator: index === 0 ? null : group.groupLogicalOperator || "AND",
			}));
		const groupIndexById = new Map(nextGroups.map((group, index) => [group.groupId, index]));
		const nextConditions = (triggerValues[scenarioKey]?.cohortConditions || [])
			.filter((condition) => condition.groupId !== groupId)
			.filter((condition) => groupIndexById.has(condition.groupId))
			.map((condition) => {
				const groupOrder = groupIndexById.get(condition.groupId);
				const group = nextGroups[groupOrder];
				return {
					...condition,
					module: group.module,
					groupOrder,
					groupLogicalOperator: groupOrder === 0 ? null : group.groupLogicalOperator || "AND",
				};
			});

		const nextNewConditionByGroupId = { ...(triggerEditor[scenarioKey]?.newConditionByGroupId || {}) };
		delete nextNewConditionByGroupId[groupId];

		this.patchScenarioEditor(scenarioKey, {
			cohortGroups: nextGroups.length ? nextGroups : [{ groupId: crypto.randomUUID(), module: "deposit", groupKey: "depositFilters", groupLogicalOperator: null }],
			newConditionByGroupId: nextNewConditionByGroupId,
		});
		this.patchScenario(scenarioKey, { cohortConditions: nextConditions });
	};

	addCohortCondition = (scenarioKey, group, groupIndex) => {
		const triggerValues = this.getTriggerValues();
		const triggerEditor = this.getTriggerEditor();
		const conditions = triggerValues[scenarioKey]?.cohortConditions || [];
		const groupConditions = conditions.filter((condition) => condition.groupId === group.groupId).sort((a, b) => (a.conditionOrder ?? 0) - (b.conditionOrder ?? 0));
		const newCondition = triggerEditor[scenarioKey]?.newConditionByGroupId?.[group.groupId] || {};

		if (!newCondition.field || newCondition.value === null || newCondition.value === "") return;

		let value = newCondition.value;
		if (newCondition.conditionalType === "select") {
			value = newCondition.value.value || newCondition.value;
		} else if (newCondition.conditionalType === "boolean") {
			value = newCondition.value ? 1 : 0;
		}

		const nextOrder = groupConditions.length ? Math.max(...groupConditions.map((condition) => condition.conditionOrder ?? 0)) + 1 : 0;
		const logicalOperator = groupConditions.length ? newCondition.logicalOperator || "AND" : null;
		const item = {
			...newCondition,
			id: crypto.randomUUID(),
			value,
			logicalOperator,
			conditionOrder: nextOrder,
			groupId: group.groupId,
			module: group.module,
			groupKey: group.groupKey || GamesSweepstakesTriggersTab.buildGroupKeyByModule(group.module),
			groupOrder: groupIndex,
			groupLogicalOperator: groupIndex === 0 ? null : group.groupLogicalOperator || "AND",
		};

		this.patchScenario(scenarioKey, {
			cohortConditions: GamesSweepstakesTriggersTab.applyGroupConditionsConsistency([...conditions, item], group.groupId),
		});
		this.resetNewCondition(scenarioKey, group.groupId);
	};

	removeCohortCondition = (scenarioKey, groupId, conditionId) => {
		const triggerValues = this.getTriggerValues();
		this.patchScenario(scenarioKey, {
			cohortConditions: GamesSweepstakesTriggersTab.applyGroupConditionsConsistency(
				(triggerValues[scenarioKey]?.cohortConditions || []).filter((condition) => condition.id !== conditionId),
				groupId,
			),
		});
	};

	buildTriggersPayload = () => {
		const triggerValues = this.getTriggerValues();
		return {
			lessThanTicket: {
				cohortConditions: triggerValues?.lessThanTicket?.cohortConditions || [],
				messages: (triggerValues?.lessThanTicket?.messages || []).map((message) => GamesSweepstakesTriggersTab.buildInternationalMessagePayloadValue(message)).filter(Boolean),
			},
			ticketToDouble: {
				cohortConditions: triggerValues?.ticketToDouble?.cohortConditions || [],
				messages: (triggerValues?.ticketToDouble?.messages || []).map((message) => GamesSweepstakesTriggersTab.buildInternationalMessagePayloadValue(message)).filter(Boolean),
			},
		};
	};

	buildTriggersJson = () => JSON.stringify(this.buildTriggersPayload(), null, 2);

	copyTextToClipboard = async (value) => {
		if (navigator.clipboard && navigator.clipboard.writeText) {
			await navigator.clipboard.writeText(value);
			return;
		}

		const textarea = document.createElement("textarea");
		textarea.value = value;
		textarea.setAttribute("readonly", "");
		textarea.style.position = "absolute";
		textarea.style.left = "-9999px";
		document.body.appendChild(textarea);
		textarea.select();
		document.execCommand("copy");
		document.body.removeChild(textarea);
	};

	syncJsonDraft = () => {
		this.setState({
			jsonDraft: this.buildTriggersJson(),
			jsonError: "",
		});
	};

	copyTriggersJson = async () => {
		const { Interface } = this.props;
		const value = this.buildTriggersJson();

		try {
			await this.copyTextToClipboard(value);
			this.setState({ jsonDraft: value, jsonError: "" });
			Interface.addNoty("Success", "Copied sweepstakes triggers JSON");
		} catch (error) {
			Interface.addNoty("Error", "Failed to copy sweepstakes triggers JSON");
		}
	};

	parseImportedTriggersJson = (value) => {
		const trimmedValue = String(value || "").trim();

		if (!trimmedValue) {
			throw new Error("Input is empty");
		}

		let parsedValue;
		try {
			parsedValue = JSON.parse(trimmedValue);
		} catch (error) {
			throw new Error(`Invalid JSON format: ${error.message}`);
		}

		if (!parsedValue || typeof parsedValue !== "object" || Array.isArray(parsedValue)) {
			throw new Error("JSON must be an object with lessThanTicket and ticketToDouble fields");
		}

		const fieldMetaByValue = new Map(GamesSweepstakesTriggersTab.buildCohortFieldOptions().map((field) => [field.value, field]));
		const importedValue = {};

		GamesSweepstakesTriggersTab.getScenarioKeys().forEach((scenarioKey) => {
			const scenario = parsedValue[scenarioKey];
			const scenarioLabel = GamesSweepstakesTriggersTab.getScenarioLabel(scenarioKey);

			if (!scenario || typeof scenario !== "object" || Array.isArray(scenario)) {
				throw new Error(`${scenarioLabel} must be an object`);
			}

			if (!Array.isArray(scenario.cohortConditions)) {
				throw new Error(`${scenarioLabel} cohortConditions must be an array`);
			}

			if (!Array.isArray(scenario.messages)) {
				throw new Error(`${scenarioLabel} messages must be an array`);
			}

			const messages = scenario.messages.map((message, index) => {
				if (typeof message !== "string") {
					throw new Error(`${scenarioLabel} message ${index + 1} must be a string`);
				}

				return message;
			});

			const cohortConditions = scenario.cohortConditions.map((condition, index) => {
				if (!condition || typeof condition !== "object" || Array.isArray(condition)) {
					throw new Error(`${scenarioLabel} condition ${index + 1} must be an object`);
				}

				const field = String(condition.field || condition.fieldLabel || "").trim();
				const fieldMeta = fieldMetaByValue.get(field);

				if (!field) {
					throw new Error(`${scenarioLabel} condition ${index + 1} field is required`);
				}

				if (!fieldMeta) {
					throw new Error(`${scenarioLabel} condition ${index + 1} uses unknown field "${field}"`);
				}

				if (!condition.operator) {
					throw new Error(`${scenarioLabel} condition ${index + 1} operator is required`);
				}

				if (condition.value === null || typeof condition.value === "undefined" || condition.value === "") {
					throw new Error(`${scenarioLabel} condition ${index + 1} value is required`);
				}

				return {
					...condition,
					field,
					fieldLabel: condition.fieldLabel || fieldMeta.label,
					conditionalType: condition.conditionalType || fieldMeta.type,
					specialType: typeof condition.specialType !== "undefined" ? condition.specialType : fieldMeta.specialType,
				};
			});

			importedValue[scenarioKey] = {
				cohortConditions,
				messages,
			};
		});

		const triggerState = GamesSweepstakesTriggersTab.buildTriggerStateFromResponse(importedValue);
		const validationError = this.validateTriggerValues(triggerState.triggerValues);

		if (validationError) {
			throw new Error(validationError);
		}

		return triggerState;
	};

	applyTriggersJson = () => {
		const { Interface } = this.props;
		const jsonDraft = typeof this.state.jsonDraft === "string" ? this.state.jsonDraft : this.buildTriggersJson();

		try {
			const triggerState = this.parseImportedTriggersJson(jsonDraft);
			const formattedValue = JSON.stringify(
				{
					lessThanTicket: {
						cohortConditions: triggerState.triggerValues.lessThanTicket.cohortConditions,
						messages: triggerState.triggerValues.lessThanTicket.messages.map((message) => GamesSweepstakesTriggersTab.buildInternationalMessagePayloadValue(message)),
					},
					ticketToDouble: {
						cohortConditions: triggerState.triggerValues.ticketToDouble.cohortConditions,
						messages: triggerState.triggerValues.ticketToDouble.messages.map((message) => GamesSweepstakesTriggersTab.buildInternationalMessagePayloadValue(message)),
					},
				},
				null,
				2,
			);

			this.props.setGamesSweepstakesModal((prev) => ({
				...prev,
				triggerValues: triggerState.triggerValues,
				triggerEditor: {
					...triggerState.triggerEditor,
					activeScenarioTab: "json",
					activeSectionTab: prev.triggerEditor?.activeSectionTab || "messages",
				},
				error: { text: "", code: 0, timestamp: 0 },
			}));
			this.setState({
				messageValidationVisibility: {},
				jsonDraft: formattedValue,
				jsonError: "",
			});
			Interface.addNoty("Success", "Sweepstakes triggers JSON was applied");
		} catch (error) {
			this.setState({ jsonError: error.message });
			Interface.addNoty("Error", error.message);
		}
	};

	validateTriggerValues = (triggerValues = this.getTriggerValues()) => {
		for (const scenarioKey of GamesSweepstakesTriggersTab.getScenarioKeys()) {
			const scenario = triggerValues?.[scenarioKey];
			if (!scenario || !Array.isArray(scenario.cohortConditions) || !scenario.cohortConditions.length) {
				return `${GamesSweepstakesTriggersTab.getScenarioLabel(scenarioKey)} cohort is required`;
			}

			const messages = (scenario.messages || []).map((message) => String(message || "").trim()).filter(Boolean);
			if (!messages.length) {
				return `${GamesSweepstakesTriggersTab.getScenarioLabel(scenarioKey)} requires at least one message`;
			}

			const invalidMessageIndex = (scenario.messages || []).findIndex((message) => GamesSweepstakesTriggersTab.getInternationalMessageValidationError(message));
			if (invalidMessageIndex !== -1) {
				return `${GamesSweepstakesTriggersTab.getScenarioLabel(scenarioKey)} message ${invalidMessageIndex + 1} must contain only the last international translation key`;
			}
		}

		return "";
	};

	save = async () => {
		const { Interface, setGamesSweepstakesModal } = this.props;
		this.showAllMessagesValidation();
		const validationError = this.validateTriggerValues();

		if (validationError) {
			this.setModalError(validationError, 400);
			Interface.addNoty("Error", validationError);
			return;
		}

		setGamesSweepstakesModal((prev) => ({
			...prev,
			loaded: false,
			error: { text: "", code: 0, timestamp: 0 },
		}));

		try {
			await Interface.request("set", { class: "data", module: "customGame", method: "updateSweepstakesEmotionalTriggers" }, this.buildTriggersPayload());
			setGamesSweepstakesModal((prev) => ({
				...prev,
				loaded: true,
				error: { text: "", code: 0, timestamp: 0 },
			}));
			Interface.addNoty("Success", "Sweepstakes triggers were successfully updated");
		} catch (error) {
			this.setModalError(error.text || error.toString(), error.code || 500);
			Interface.addNoty("Error", error.text || error.toString());
		}
	};

	renderComponentFromType = (scenarioKey, groupId, type, specialType) => {
		const triggerEditor = this.getTriggerEditor();
		const newCondition = triggerEditor[scenarioKey]?.newConditionByGroupId?.[groupId] || {};

		if (type === "string") {
			return <Input placeholder="Enter value" value={newCondition?.value || ""} onChange={(event) => this.updateNewCondition(scenarioKey, groupId, { value: event.detail.value })} />;
		}
		if (type === "count") {
			return <Input placeholder="Enter value" type="number" value={newCondition?.value || ""} onChange={(event) => this.updateNewCondition(scenarioKey, groupId, { value: event.detail.value })} />;
		}
		if (type === "date") {
			return <DatePicker onChange={({ detail }) => this.updateNewCondition(scenarioKey, groupId, { value: detail.value })} value={newCondition?.value || null} placeholder="Select a date" />;
		}
		if (type === "select" && specialType === "boolean") {
			return (
				<Select
					selectedOption={newCondition?.value}
					onChange={({ detail }) => this.updateNewCondition(scenarioKey, groupId, { value: detail.selectedOption })}
					options={[
						{ value: "1", label: "Required" },
						{ value: "0", label: "No" },
					]}
					placeholder="Select type"
				/>
			);
		}
		if (type === "select" && specialType === "cryptoOrFiat") {
			return (
				<Select
					selectedOption={newCondition?.value}
					onChange={({ detail }) => this.updateNewCondition(scenarioKey, groupId, { value: detail.selectedOption })}
					options={[
						{ value: "crypto", label: "Crypto" },
						{ value: "fiat", label: "Fiat" },
					]}
					placeholder="Select type"
				/>
			);
		}
		if (type === "select" && specialType === "partnerPaymentType") {
			return (
				<Select
					selectedOption={newCondition?.value}
					onChange={({ detail }) => this.updateNewCondition(scenarioKey, groupId, { value: detail.selectedOption })}
					options={PARTNER_PAYMENT_TYPE_OPTIONS}
					placeholder="Select payment type"
				/>
			);
		}

		return null;
	};

	renderJsonEditor = () => {
		const { gamesSweepstakesModal } = this.props;
		const jsonDraft = typeof this.state.jsonDraft === "string" ? this.state.jsonDraft : this.buildTriggersJson();

		return (
			<Container header={<Header variant="h2">Sweepstakes triggers JSON</Header>}>
				<SpaceBetween size="m">
					<Box color="text-body-secondary">
						Copy the full triggers JSON or paste JSON from another project. Apply JSON updates the form only; use Save triggers to persist it.
					</Box>
					<SpaceBetween direction="horizontal" size="xs">
						<Button onClick={this.copyTriggersJson} disabled={!gamesSweepstakesModal.loaded}>
							Copy JSON
						</Button>
						<Button variant="primary" onClick={this.applyTriggersJson} disabled={!gamesSweepstakesModal.loaded}>
							Apply JSON
						</Button>
					</SpaceBetween>
					<FormField
						label="Triggers JSON"
						description='Expected fields: "lessThanTicket" and "ticketToDouble", each with "cohortConditions" and "messages".'
						errorText={this.state.jsonError}
						stretch>
						<Textarea
							value={jsonDraft}
							onChange={({ detail }) =>
								this.setState({
									jsonDraft: detail.value,
									jsonError: "",
								})
							}
							placeholder={`{\n  "lessThanTicket": {\n    "cohortConditions": [],\n    "messages": []\n  },\n  "ticketToDouble": {\n    "cohortConditions": [],\n    "messages": []\n  }\n}`}
							rows={24}
							disabled={!gamesSweepstakesModal.loaded}
						/>
					</FormField>
				</SpaceBetween>
			</Container>
		);
	};

	renderScenario = (scenarioKey) => {
		const { gamesSweepstakesModal } = this.props;
		const triggerValues = this.getTriggerValues();
		const triggerEditor = this.getTriggerEditor();
		const scenarioValue = triggerValues[scenarioKey] || GamesSweepstakesTriggersTab.createEmptyTriggerScenarioState();
		const scenarioEditor = triggerEditor[scenarioKey] || GamesSweepstakesTriggersTab.createEmptyTriggerEditorScenarioState();
		const scenarioMessages = scenarioValue.messages || [""];
		const totalMessages = scenarioMessages.filter((message) => String(message || "").trim()).length;
		const groups = scenarioEditor.cohortGroups || [];
		const totalCohorts = groups.length;
		const activeSectionTab = triggerEditor.activeSectionTab || "messages";
		const moduleOptions = GamesSweepstakesTriggersTab.buildCohortModuleOptions();
		const logicalOperatorOptions = GamesSweepstakesTriggersTab.buildLogicalOperatorOptions();
		const sectionTabs = [
			{ id: "messages", label: "Messages", content: null },
			{ id: "cohortSettings", label: "Cohort settings", content: null },
		];

		return (
			<SpaceBetween size="l">
				<Tabs
					tabs={[
						{
							id: "messages",
							label: `Messages${totalMessages ? ` (${totalMessages})` : ""}`,
							content: (
								<Container>
									<SpaceBetween size="m">
										<Box variant="p">{GamesSweepstakesTriggersTab.getInternationalMessageDescription()}</Box>
										<div style={{ maxHeight: "500px", minHeight: "200px", overflowY: "auto", overflowX: "hidden", paddingRight: "8px" }}>
											<SpaceBetween size="m">
												{scenarioMessages.map((message, index) => (
													<FormField stretch label={`Message ${index + 1}`} description={String(message || "").trim() ? `Will be sent as ${GamesSweepstakesTriggersTab.buildInternationalMessagePayloadValue(message)}` : "Enter a key to see the value that will be sent."} errorText={this.isMessageValidationVisible(scenarioKey, index) ? GamesSweepstakesTriggersTab.getInternationalMessageValidationError(message) : ""}>
														<div key={`${scenarioKey}_message_${index}`} style={{ display: "flex", width: "100%", alignItems: "center", gap: "10px" }}>
															<div style={{ flex: "1" }}>
																<Input value={message} placeholder="key" onChange={(event) => this.updateScenarioMessage(scenarioKey, index, event.detail.value)} onBlur={() => this.showMessageValidation(scenarioKey, index)} disabled={!gamesSweepstakesModal.loaded} />
															</div>

															<Button iconName="copy" onClick={() => navigator.clipboard.writeText(`triggersText.${String(message || "").trim()}`)} disabled={!gamesSweepstakesModal.loaded || !String(message || "").trim()} />

															<Button variant="icon" iconName="delete-marker" onClick={() => this.removeScenarioMessage(scenarioKey, index)} disabled={!gamesSweepstakesModal.loaded}>
																Remove message
															</Button>
														</div>
													</FormField>
												))}
											</SpaceBetween>
										</div>
										<Box>
											<Button variant="primary" iconName="add-plus" onClick={() => this.addScenarioMessage(scenarioKey)} disabled={!gamesSweepstakesModal.loaded}>
												Add message
											</Button>
										</Box>
									</SpaceBetween>
								</Container>
							),
						},
						{
							id: "cohortSettings",
							label: `Cohort settings${totalCohorts ? ` (${totalCohorts})` : ""}`,
							content: (
								<Container header={<Header variant="h2">Cohort settings</Header>}>
									<SpaceBetween size="l">
										<Box variant="awsui-key-label">Total cohorts: {totalCohorts}</Box>
										<Box>
											<Button variant="primary" iconName="add-plus" onClick={() => this.addCohortGroup(scenarioKey)} disabled={!gamesSweepstakesModal.loaded}>
												Add group
											</Button>
										</Box>
										<div style={{ maxHeight: "520px", overflowY: "auto", paddingRight: "8px" }}>
											<SpaceBetween size="l">
												{groups.map((group, groupIndex) => {
													const selectedModule = moduleOptions.find((option) => option.value === group.module) || null;
													const groupOperatorValue = groupIndex === 0 ? "AND" : group.groupLogicalOperator || "AND";
													const selectedGroupLogicalOperator = logicalOperatorOptions.find((option) => option.value === groupOperatorValue) || null;
													const groupConditions = (scenarioValue.cohortConditions || []).filter((condition) => condition.groupId === group.groupId).sort((a, b) => (a.conditionOrder ?? 0) - (b.conditionOrder ?? 0));
													const newCondition = scenarioEditor.newConditionByGroupId?.[group.groupId] || {};
													const selectedConditionLogicalOperator = logicalOperatorOptions.find((option) => option.value === (newCondition.logicalOperator || "AND")) || null;
													const fieldOptions = GamesSweepstakesTriggersTab.buildCohortFieldOptionsByModule(group.module);
													const selectedFieldOption = newCondition.field ? { value: newCondition.field, label: newCondition.fieldLabel } : null;
													const selectedOperatorOption = newCondition.operator ? { value: newCondition.operator, label: newCondition.operator } : null;
													const isAddDisabled = !newCondition.field || newCondition.value === null || newCondition.value === "" || (!newCondition.operator && newCondition.conditionalType !== "select");

													return (
														<Container
															key={group.groupId}
															header={
																<Header
																	variant="h3"
																	actions={
																		<Button variant="icon" iconName="delete-marker" onClick={() => this.removeCohortGroup(scenarioKey, group.groupId)} disabled={!gamesSweepstakesModal.loaded}>
																			Remove group
																		</Button>
																	}>
																	{`Group ${groupIndex + 1}`}
																</Header>
															}>
															<SpaceBetween size="m">
																<Grid gridDefinition={[{ colspan: 4 }, { colspan: 4 }, { colspan: 4 }]}>
																	<FormField label="Module" stretch>
																		<Select selectedOption={selectedModule} onChange={({ detail }) => this.changeCohortGroupModule(scenarioKey, group.groupId, detail.selectedOption.value)} options={moduleOptions} placeholder="Select module" disabled={!gamesSweepstakesModal.loaded} />
																	</FormField>
																	<FormField label="Group operator" stretch>
																		<Select
																			selectedOption={selectedGroupLogicalOperator}
																			onChange={({ detail }) => {
																				if (groupIndex === 0) return;
																				this.updateCohortGroup(scenarioKey, group.groupId, { groupLogicalOperator: detail.selectedOption.value });
																			}}
																			options={logicalOperatorOptions}
																			placeholder="Select operator"
																			disabled={groupIndex === 0 || !gamesSweepstakesModal.loaded}
																		/>
																	</FormField>
																	<Box />
																</Grid>

																<Table
																	columnDefinitions={[
																		{ id: "logic", header: "Logic", cell: (item) => item.logicalOperator || "-" },
																		{ id: "field", header: "Field", cell: (item) => item.fieldLabel || item.field },
																		{ id: "operator", header: "Operator", cell: (item) => item.operator },
																		{ id: "value", header: "Value", cell: (item) => item.value },
																		{
																			id: "actions",
																			header: "Control",
																			cell: (item) => (
																				<Button variant="icon" iconName="delete-marker" onClick={() => this.removeCohortCondition(scenarioKey, group.groupId, item.id)} disabled={!gamesSweepstakesModal.loaded}>
																					Remove
																				</Button>
																			),
																		},
																	]}
																	footer={
																		<FormField stretch label="Add condition">
																			<Grid gridDefinition={groupConditions.length ? [{ colspan: 2 }, { colspan: 4 }, { colspan: 2 }, { colspan: 2 }, { colspan: 2 }] : [{ colspan: 4 }, { colspan: 3 }, { colspan: 3 }, { colspan: 2 }]}>
																				{groupConditions.length > 0 && <Select selectedOption={selectedConditionLogicalOperator} placeholder="AND/OR" options={logicalOperatorOptions} onChange={({ detail }) => this.updateNewCondition(scenarioKey, group.groupId, { logicalOperator: detail.selectedOption.value })} disabled={!gamesSweepstakesModal.loaded} />}
																				<Select
																					selectedOption={selectedFieldOption}
																					placeholder="Select field"
																					options={fieldOptions}
																					onChange={({ detail }) =>
																						this.updateNewCondition(scenarioKey, group.groupId, {
																							field: detail.selectedOption.value,
																							fieldLabel: detail.selectedOption.label,
																							conditionalType: detail.selectedOption.type,
																							specialType: detail.selectedOption.specialType,
																							value: null,
																							operator: detail.selectedOption.type === "select" ? "=" : null,
																						})
																					}
																					disabled={!gamesSweepstakesModal.loaded}
																				/>
																				<Select
																					selectedOption={selectedOperatorOption}
																					placeholder="Select operator"
																					disabled={newCondition.conditionalType === "select" || !gamesSweepstakesModal.loaded}
																					options={[
																						{ value: "=", label: "=" },
																						{ value: ">", label: ">" },
																						{ value: "<", label: "<" },
																						{ value: ">=", label: ">=" },
																						{ value: "<=", label: "<=" },
																						{ value: "IN", label: "IN" },
																					]}
																					onChange={({ detail }) => this.updateNewCondition(scenarioKey, group.groupId, { operator: detail.selectedOption.value })}
																				/>
																				<Box>{this.renderComponentFromType(scenarioKey, group.groupId, newCondition.conditionalType, newCondition.specialType)}</Box>
																				<Button disabled={isAddDisabled || !gamesSweepstakesModal.loaded} onClick={() => this.addCohortCondition(scenarioKey, group, groupIndex)}>
																					+ Add
																				</Button>
																			</Grid>
																		</FormField>
																	}
																	items={groupConditions}
																	empty="No conditions set"
																/>
															</SpaceBetween>
														</Container>
													);
												})}
											</SpaceBetween>
										</div>
									</SpaceBetween>
								</Container>
							),
						},
					]}
					activeTabId={activeSectionTab}
					onChange={({ detail }) => this.setActiveSectionTab(detail.activeTabId)}
				/>
			</SpaceBetween>
		);
	};

	render() {
		const triggerEditor = this.getTriggerEditor();
		const tabs = [
			{ id: "lessThanTicket", label: "Prize < ticket", content: this.renderScenario("lessThanTicket") },
			{ id: "ticketToDouble", label: "Prize x1-x2", content: this.renderScenario("ticketToDouble") },
			{ id: "json", label: "JSON", content: this.renderJsonEditor() },
		];
		const activeTabId = tabs.some((tab) => tab.id === triggerEditor.activeScenarioTab) ? triggerEditor.activeScenarioTab : "lessThanTicket";

		return <Tabs tabs={tabs} activeTabId={activeTabId} onChange={({ detail }) => this.setActiveScenarioTab(detail.activeTabId)} />;
	}
}

export default GamesSweepstakesTriggersTab;
